import React, { useEffect } from "react";
import { HashRouter as Router } from 'react-router-dom';
import { useTypedSelector, useTypedDispatch } from "../../hooks/typed";

import { selectThemes, setMode, setColor } from "../../store/themes/themes.slice";

import Header from "../header/Header";
import Pages from "../Pages";

import './layout.scss';

import textureBg2 from "../../images/texture-bg-2.svg";
import textureBg1 from "../../images/texture-bg-1.svg";
import textureBg from "../../images/texture-bg.svg";

const Layout: React.FC = () => {

    const themesReducer = useTypedSelector(selectThemes);
    const dispath = useTypedDispatch();

    useEffect(() => {
        const themeClass = localStorage.getItem('themeMode') || 'theme-mode-dark';
        const colorClass = localStorage.getItem('colorMode') || 'theme-color-orange';

        dispath(setMode(themeClass));
        dispath(setColor(colorClass));
    
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Router>
            <div className={`layout ${themesReducer.mode} ${themesReducer.color}`}>
                <div className="layout__content">
                    <Header />
                    <div className="layout__content-main">
                        <div className="texture-bg-wrape">
                            {/* <img src={textureBg2} alt="" /> */}
                            {/* <img src={textureBg1} alt="" /> */}
                            {/* <img src={textureBg} alt="" /> */}
                        </div>
                        <Pages />
                    </div>
                </div>
                {/* <div className="layout__footer">
                    <h3>Powered by BscScan APIs</h3>
                </div> */}
            </div>
        </Router>
    )
};

export default Layout;